import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@/shared/lib'
import { Icon } from '@/shared/ui/Icon'
import { IconButton } from '@/shared/ui/IconButton'
import { Menu } from '@/shared/ui/Menu'
import { Popover } from '@/shared/ui/Popover'
import { THEME_ICON, useThemeMenuGroup } from './useThemeMenuGroup'

/**
 * Выбор темы оформления в шапке кабинета: светлая, тёмная или как в системе. Тема меняется
 * сразу и хранится в браузере (`ThemeProvider`) — ни сеанс, ни бэк о ней не знают.
 */
export function ThemeSwitch() {
  const { t } = useTranslation()
  const { theme } = useTheme()
  const group = useThemeMenuGroup()
  const anchorRef = useRef<HTMLButtonElement>(null)
  const [open, setOpen] = useState(false)

  return (
    <>
      <IconButton
        ref={anchorRef}
        icon={<Icon name={THEME_ICON[theme]} size="md" />}
        label={t('theme.trigger', { value: t(`theme.${theme}`) })}
        variant="secondary"
        size="md"
        expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen((value) => !value)}
      />

      <Popover anchorRef={anchorRef} open={open} onOpenChange={setOpen} placement="bottom-end">
        <Menu label={group.label} items={group.items} autoFocus onSelect={() => setOpen(false)} />
      </Popover>
    </>
  )
}
